export default __webpack_public_path__ + "static/media/kpi-api-calls.7c112be5.svg";